import { z } from "zod";

export default z.object({ "firstDt": z.string().describe("최초 태깅 일시").optional(), "lastDt": z.string().describe("최종 태깅 일시").optional(), "firstInDt": z.string().describe("최초 입구 태깅 일시").optional(), "lastOutDt": z.string().describe("최종 출구 일시").optional() }).describe("세콤 태깅 (게이트 포함)");
